export const availabilityStates = ['0', '1'];
